import { render, staticRenderFns } from "./trainItem.vue?vue&type=template&id=16c382d5&scoped=true&"
import script from "./trainItem.vue?vue&type=script&lang=js&"
export * from "./trainItem.vue?vue&type=script&lang=js&"
import style0 from "./trainItem.vue?vue&type=style&index=0&id=16c382d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c382d5",
  null
  
)

export default component.exports